import { Field } from '@/types/partnerConfig'

type FieldNoName = Omit<Field, 'name'>

const DEFAULTS: Pick<Field, 'required' | 'disabled'> = {
  required: true,
  disabled: false,
}

export const TEXT_FIELD: FieldNoName = {
  ...DEFAULTS,
  type: 'text',
}

export const SELECT_FIELD: FieldNoName = {
  ...DEFAULTS,
  type: 'select',
}

const premadeFields: { [key: string]: Field } = {
  EMAIL: {
    ...TEXT_FIELD,
    name: 'email',
    type: 'email',
  },
  FIRST_NAME: {
    ...TEXT_FIELD,
    name: 'first_name',
  },
  LAST_NAME: {
    ...TEXT_FIELD,
    name: 'last_name',
  },
  MIDDLE_NAME: {
    ...TEXT_FIELD,
    name: 'middle_name',
    required: false,
  },
  CURRENT_GP: {
    ...SELECT_FIELD,
    name: 'current_gp',
    controller: 'membershipCode',
  },
  PASSWORD: {
    ...TEXT_FIELD,
    name: 'password',
    type: 'password',
  },
  DATE_OF_BIRTH: {
    ...DEFAULTS,
    name: 'date_of_birth',
    type: 'dateOfBirth',
  },
  DATE_OF_BIRTH_US: {
    ...DEFAULTS,
    name: 'date_of_birth_us',
    type: 'dateOfBirth',
    labelKey: 'date_of_birth_us',
  },
  DATE_OF_BIRTH_V2: {
    ...DEFAULTS,
    name: 'date_of_birth_v2',
    type: 'dateOfBirth',
  },
  POSTCODE: {
    ...TEXT_FIELD,
    name: 'address_post_code',
    labelKey: 'postcode',
    validationKey: 'postcode',
  },
  ZIPCODE_V2: {
    ...TEXT_FIELD,
    name: 'address_post_code_v2',
    type: 'zipcode',
    labelKey: 'zipcode',
    validationKey: 'zipcode',
  },
  ZIPCODE: {
    ...TEXT_FIELD,
    name: 'address_post_code',
    type: 'zipcode',
    labelKey: 'zipcode',
    validationKey: 'zipcode',
  },
  GENDER: {
    ...DEFAULTS,
    name: 'gender',
    type: 'gender',
  },
  PHONE_COUNTRY_CODE: {
    ...DEFAULTS,
    name: 'phone_country_code',
    type: 'phoneCountryCode',
  },
  PHONE_NUMBER: {
    ...DEFAULTS,
    name: 'phone_number',
    type: 'tel',
  },
  PHONE_NUMBER_V2: {
    ...DEFAULTS,
    name: 'phone_number_v2',
    type: 'tel',
  },
  ADDRESS_STATE_CODE: {
    ...SELECT_FIELD,
    name: 'address_state_code',
  },
}

export default premadeFields
